import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';
import { WithdrawalLogModel } from '../Models/withdrawal-log.model';
import { ReturnLogModel } from '../Models/return-log.model';

export interface ActivityLogModel {
  id: number;
  userId: string;
  action: string;
  timestamp: string;
}

export interface ReportSummary {
  totalWithdrawals: number;
  totalReturns: number;
  totalActivities: number;
  totalWithdrawnQty: number;
  totalReturnedQty: number;
  topUsers: { userId: string; userName: string; withdrawalCount: number; totalQuantity: number }[];
}

export interface ReportUser {
  id: string;
  userName: string;
  email: string;
}

@Injectable({
  providedIn: 'root'
})
export class ReportsService {
  private apiUrl = environment.apiBaseUrl + '/Reports';

  constructor(private http: HttpClient) {}

  private buildParams(from?: string, to?: string, userId?: string): HttpParams {
    let params = new HttpParams();
    if (from) params = params.set('from', from);
    if (to) params = params.set('to', to);
    if (userId) params = params.set('userId', userId);
    return params;
  }

  getActivityLogs(from?: string, to?: string, userId?: string): Observable<ActivityLogModel[]> {
    return this.http.get<ActivityLogModel[]>(`${this.apiUrl}/activity-logs`, {
      params: this.buildParams(from, to, userId)
    });
  }

  getWithdrawals(from?: string, to?: string, userId?: string): Observable<WithdrawalLogModel[]> {
    return this.http.get<WithdrawalLogModel[]>(`${this.apiUrl}/withdrawals`, {
      params: this.buildParams(from, to, userId)
    });
  }

  getReturns(from?: string, to?: string, userId?: string): Observable<ReturnLogModel[]> {
    return this.http.get<ReturnLogModel[]>(`${this.apiUrl}/returns`, {
      params: this.buildParams(from, to, userId)
    });
  }

  getSummary(from?: string, to?: string): Observable<ReportSummary> {
    return this.http.get<ReportSummary>(`${this.apiUrl}/summary`, {
      params: this.buildParams(from, to)
    });
  }

  getUsers(): Observable<ReportUser[]> {
    return this.http.get<ReportUser[]>(`${this.apiUrl}/users`);
  }
}
